import {
    SET_TRANSFER_GRID_COUNT,
    SET_TRANSFER_GRID_DATA,
    IS_MY_ORDERS_GRID_LOADING,
    IS_MY_ORDERS_GRID_COUNTS_LOADING
} from './TransferGridType';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_TRANSFER_GRID_DATA:
            return {
                ...state,
                transferGridData: action.transferGridData,
            };
        case SET_TRANSFER_GRID_COUNT:
            return {
                ...state,
                transferGridCount: action.gridCount,
            };
        case IS_MY_ORDERS_GRID_LOADING:
            return {
                ...state,
                isMyOrdersGridLoading: action.flag,
            };
        case IS_MY_ORDERS_GRID_COUNTS_LOADING:
            return {
                ...state,
                isMyOrdersGridCountsLoading: action.flag,
            };
        default:
            return state;
    }
}

export {
    reducers
}